export default "__VITE_ASSET__d6a75058__"